import { render } from "./range.vue?vue&type=template&id=06c4dc92"
import script from "./range.vue?vue&type=script&lang=js"
export * from "./range.vue?vue&type=script&lang=js"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/range.vue'],['render',render],['__file',"range.vue"]])

export default __exports__